import * as React from "react";

function ContestIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width='40'
      height='41'
      viewBox='0 0 40 41'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <g filter='url(#filter0_i)'>
        <path
          d='M32 0.5C30.2 0.5 28 2.5 28 4.5H12C12 2.5 9.8 0.5 8 0.5H0V18.5C0 20.5 2 22.5 4 22.5H8.4C9.2 26.5 11.8 29.9 18 30.5V34.66C12 35.58 12 40.5 12 40.5H28C28 40.5 28 35.58 22 34.66V30.5C28.2 29.9 30.8 26.5 31.6 22.5H36C38 22.5 40 20.5 40 18.5V0.5H32ZM8 18.5H4V4.5H8V18.5ZM36 18.5H32V4.5H36V18.5Z'
          fill='white'
        />
      </g>
      <defs>
        <filter
          id='filter0_i'
          x='0'
          y='-7.5'
          width='40'
          height='48'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend
            mode='normal'
            in='SourceGraphic'
            in2='BackgroundImageFix'
            result='shape'
          />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset dy='-8' />
          <feGaussianBlur stdDeviation='8' />
          <feComposite in2='hardAlpha' operator='arithmetic' k2='-1' k3='1' />
          <feColorMatrix
            type='matrix'
            values='0 0 0 0 0.988235 0 0 0 0 0.823529 0 0 0 0 0.0235294 0 0 0 1 0'
          />
          <feBlend mode='normal' in2='shape' result='effect1_innerShadow' />
        </filter>
      </defs>
    </svg>
  );
}

export default ContestIcon;